import BaseHttpClient from './BaseHttpClient';
import ApiQueryOption from '@/models/base/ApiQueryOption.model';
import { AxiosResponse } from 'axios';
import HttpStatusCode from '@/enums/HttpStatusCode';

export default class BaseRepository<T> {
    public client: BaseHttpClient;
    constructor(public controller: string) {
        this.client = new BaseHttpClient(controller);
    }
    public async getById(id: number | string, params = new ApiQueryOption()): Promise<T> {
        try {
            return await this.client.getAsync(id.toString(), params);
        } catch (error) {
            throw error;
        }
    }
    public async get(params = new ApiQueryOption(), resource = String()): Promise<T[]> {
        try {
            return await this.client.getAsync<T[]>(resource, params)
        } catch (error) {
            throw error;
        }
    }
    public async create(entity: T, params?: object): Promise<T> {
        try {
            return await this.client.postAsync<T>(String(), entity, params);
        } catch (error) {
            var errors: any[] = [];
            if (error.data && error.data.length > 0) {
                var errorMessages = error.data as any[];
                errorMessages.forEach(x => errors.push(x.errorMessage));
                throw errors;
            } else {
                errors.push(error);
            }
            throw errors;
        }
    }
    public async update(id: number, entity: T, params?: object): Promise<T> {
        try {
            return this.client.putAsync<T>(String(), id, entity, params);
        } catch (error) {
            var errors: any[] = [];
            if (error.data && error.data.length > 0) {
                var errorMessages = error.data as any[];
                errorMessages.forEach(x => errors.push(x.errorMessage));
                throw errors;
            } else {
                errors.push(error);
            }
            throw errors;
        }
    }
    public async updateForo(id: string, entity: T, params?: object): Promise<T> {
        try {
            return this.client.putAsyncForo<T>(String(), id, entity, params);
        } catch (error) {
            var errors: any[] = [];
            if (error.data && error.data.length > 0) {
                var errorMessages = error.data as any[];
                errorMessages.forEach(x => errors.push(x.errorMessage));
                throw errors;
            } else {
                errors.push(error);
            }
            throw errors;
        }
    }

    public async delete(id: number, params?: object): Promise<T> {
        try {
            return await this.client.deleteAsync<T>(String(), id, params);
        } catch (error) {
            throw error;
        }
    }
    public async byId(id: number, include: string = String(), resource = String()): Promise<T> {
        return this.one(`id=${id}`, include, resource);
    }
    public async first(params = new ApiQueryOption()): Promise<T> {
        params.perpage = 1;
        let result = await this.get(params);
        return result[0];
    }
    public async one(where: string, include: string = String(), resource = String()): Promise<T> {
        let params = new ApiQueryOption(undefined, where);
        params.perpage = 1;
        if (include)
            params.include = include
        let result = await this.get(params, resource);
        return result[0];
    }
    public async many(where: string, include = String(), count: number = 2000, order = 'id', resource = String()): Promise<T[]> {
        let params = new ApiQueryOption(undefined, where);
        params.perpage = count;
        params.orderby = order;
        if (include)
            params.include = include
        return await this.get(params, resource);
    }
    public async single(where: string, params = new ApiQueryOption()): Promise<T> {
        params.where = where;
        params.perpage = 1;
        let result = await this.get(params);
        return result[0];
    }
    public async search(where: string, params = new ApiQueryOption()): Promise<T[]> {
        params.where = where;
        return this.get(params);
    }
    public async macthAnd(where: T | any, params = new ApiQueryOption()): Promise<T[]> {
        let queryArry = [];
        for (let prop in where) {
            if (where[prop] !== undefined)
                queryArry.push(`${prop}=${where[prop]}`);
        }
        params.where = queryArry.join('&&');
        return await this.get(params);
    }
    public async macthOr(where: T | any, params = new ApiQueryOption()): Promise<T[]> {
        let queryArry = [];
        for (let prop in where) {
            if (where[prop] !== undefined)
                queryArry.push(`${prop}=${where[prop]}`);
        }
        params.where = queryArry.join('||');
        return await this.get(params);
    }

}
